// extracted by mini-css-extract-plugin
module.exports = {"container":"SubLinks_container__481zk","links-container":"SubLinks_links-container__qZ2p6","links-item":"SubLinks_links-item__XOvcb"};